import { Typography } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { NotConfiguredProps } from './types'

const NotConfigured: React.VFC<NotConfiguredProps> = (props) => {
  const name = useCIMSNotificationsPanelContext().event.name
  const common =
    'No Recipients have been configured to receive an email for' as const
  if (props.type === 'Every')
    return (
      <Typography.Text>
        {common} every {name} event, on every Issue
      </Typography.Text>
    )
  return (
    <Typography.Text>
      {common} {name} events where {props.name} is the {props.type}
    </Typography.Text>
  )
}

export default NotConfigured
